export const SS_CHANGE_GLOBAL_UNITS = 'SS_CHANGE_GLOBAL_UNITS';
export const SS_FETCH_SECTION_DATA = 'SS_FETCH_SECTION_DATA';
export const SS_LOAD_OUTPUTS = 'SS_LOAD_OUTPUTS';
export const SS_CHANGE_GEOMETRY = 'SS_CHANGE_GEOMETRY';
